import { truncateName } from "@/api/helper";
import Badge from "@/components/core/badge";
import DataTable, { type ColumnDef } from "@/components/core/data-table";
import Pagination from "@/components/core/pagination";
import { Route } from "@/routes/_dashboard.occ-dashboard";
import { formatDate } from "@/utils/format-date";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { caseRecordsQueryOptions } from "../case-record/api/queries/case-records-query";
import type { CaseRecord } from "../case-record/types/case-records";

export default function IncomingCases() {
	const search = Route.useSearch();
	const navigate = useNavigate();

	const casesQuery = useSuspenseQuery(
		caseRecordsQueryOptions({
			status: "pending",
		}),
	);

	const meta = casesQuery.data.meta;
	const cases = casesQuery.data?.data;

	const columns: ColumnDef<CaseRecord>[] = [
		{
			id: "case_title",
			label: "Case Title",
			cellClassName: "min-w-[250px]",
			cell: ({ data, onClick }) => (
				<Link
					to={`/case-classification/${data.id}?status=${data.status}`}
					className="font-semibold text-blue-600 hover:text-blue-500"
				>
					{truncateName(data.case_title, 30)}
				</Link>
			),
		},
		{
			id: "court_office",
			label: "Court Station/Office",
			cellClassName: "min-w-[200px]",
			cell: ({ data }) => data.station,
		},
		{
			id: "filed_at",
			label: "Date Filed",
			cellClassName: "min-w-[120px]",
			cell: ({ data }) => formatDate(data.filed_at),
		},
	];

	return (
		<div className="flex flex-col w-full h-full rounded-md border border-border/50 overflow-hidden">
			<div className="flex flex-col w-full py-1 px-3">
				<DataTable
					className="border-collapse"
					data={cases}
					columns={columns}
					stickyHead={false}
					stickyCol={false}
					maxHeight={400}
					showBorder={false}
					compact={false}
				/>

				<Pagination
					onClick={async (page) => {
						await navigate({
							to: "/occ-dashboard",
							search: (old) => ({
								...old,
								page,
							}),
						});
					}}
					initialPage={meta.current_page}
					pageCount={meta.last_page}
				/>
			</div>
		</div>
	);
}
